/** Local demo paths — files in public/demo-hero/ (from your photoshoot screenshots). */

export const DEMO_HERO_IMAGE_PATHS = [
  '/demo-hero/photoshoot-1.png',
  '/demo-hero/photoshoot-2.png',
  '/demo-hero/photoshoot-3.png',
  '/demo-hero/photoshoot-4.png',
  '/demo-hero/photoshoot-5.png',
  '/demo-hero/photoshoot-6.png',
  '/demo-hero/photoshoot-7.png',
  '/demo-hero/photoshoot-8.png',
];

/** Skip slide 4 — baked-in exhibition date overlay; use clean shots in the carousel. */
const DEMO_ENABLED = new Set([0, 1, 2, 4, 5, 6]);

export function buildDemoHeroSlides() {
  return DEMO_HERO_IMAGE_PATHS.map((image, i) => ({
    enabled: DEMO_ENABLED.has(i),
    image,
    alt: `Saloni Designs photoshoot ${i + 1}`,
    link: '/shop',
    focal_x: 50,
    focal_y: 42,
  }));
}

export function shouldApplyDemoHeroInDev(slides) {
  if (process.env.NODE_ENV !== 'development') return false;
  const list = Array.isArray(slides) ? slides : [];
  return !list.some((s) => s && String(s.image || '').trim());
}
